const formatter = (row: any, col: any) => {
  const prop = String(col.property)
  return row.attributes[prop]
}

export const getSummaries = ({
  columns,
  data
}: {
  columns: any
  data: any
}) => {
  const sums: any = []
  columns.forEach((column: any, index: number) => {
    if (index === 0) {
      sums[index] = 'Total'
      return
    }
    const values = data.map((item: any) => Number(item[column.property]))
    if (!values.every((value: any) => isNaN(value))) {
      const total = values.reduce((prev: any, curr: any) => {
        const value = Number(curr)
        if (!isNaN(value)) {
          return prev + curr
        } else {
          return prev
        }
      }, 0)
      sums[index] = `$${Number(total).toFixed(2)}`
    } else {
      sums[index] = 'N/A'
    }
  })

  return sums
}

export default formatter
